<template>
  <div class="file-preview__container">
    <v-card v-for="(item, i) in items" :key="i" class="file-preview__item">
      <v-btn
        v-if="showDownload"
        icon
        @click="$emit('download', item)"
        small
        :class="btnClasses"
      >
        <i class="bexsicon-download" />
      </v-btn>
      <v-btn
        v-if="showRemove"
        icon
        @click="$emit('remove', item)"
        small
        :class="btnClasses"
      >
        <i class="bexsicon-close" />
      </v-btn>
      <v-layout
        justify-space-between
        column
        fill-height
        wrap
        class="overflow-hidden"
      >
        <v-img max-height="100px" width="100%" :src="item[fileProp]"></v-img>
        <v-card-title>
          <div class="text-truncate2">{{ item[titleProp] }}</div>
        </v-card-title>
      </v-layout>
    </v-card>
  </div>
</template>
<script>
export default {
  props: {
    showRemove: Boolean,
    showDownload: Boolean,
    fileProp: {
      type: String,
      default: 'file',
    },
    titleProp: {
      type: String,
      default: 'title',
    },
    items: {
      type: Array,
      required: true,
    },
    btnClasses: String,
  },
};
</script>
<style lang="scss" scoped>
.file-preview {
  &__container {
    display: flex;
    flex-flow: row;
    flex-flow: wrap;
  }

  &__item {
    height: 150px;
    width: 100px;
    margin: 10px 10px 0 0;
    border: 1px solid #eeeded;
    box-shadow: none !important;
    position: relative;

    .v-card__title {
      padding: 0.25em !important;
      font-size: 0.9em;
      overflow: hidden;
      margin-top: auto;
      word-wrap: break-word;
      color: var(--light-dark-color);
    }

    .v-btn {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 99;
      font-size: 0.5em;
      width: 25px;
      margin: 5px;
      height: 25px;
      border-radius: 30px !important;
      padding: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/FilePreview.vue